import { render, staticRenderFns } from "./NoteEntry.vue?vue&type=template&id=04053d14"
import script from "./NoteEntry.vue?vue&type=script&lang=js"
export * from "./NoteEntry.vue?vue&type=script&lang=js"
import style0 from "./NoteEntry.vue?vue&type=style&index=0&id=04053d14&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Avatar.vue').default})
